<template>
  <div>
    <div v-show="show">
      <div class="overview-box">
        <div class="flex">
          <div style="width: 180px">
            <el-image
              style="width: 100%"
              src="https://imgcdn.hemiao100.com/ThemePictures/%E7%94%9F%E7%90%86%E8%BD%B4%402x.png"
              fit="fill"
            ></el-image>
          </div>
          <div class="flex flex-column flex-between ml20">
            <div class="flex-1">
              <div class="tit">生理轴营销</div>
              <div class="item-tip">
                生理轴营销基于禾苗大数据的能力，集用户画像/精准推送/数据分析/孕妇生理轴/宝宝生理轴精准营销解决方案，并通过精细化的有效触达和营销服务，
              </div>
              <div class="item-tip">
                实帮助商家精准触达消费者，最终实现商家转化率提升。
              </div>
            </div>
            <div class="flex-1 mt20">
              <el-button
                size="small"
                type="primary"
                :loading="isLoading"
                @click="dialogVisible = true"
                >立即使用</el-button
              >
            </div>
          </div>
        </div>
        <el-dialog
          title="开启生理轴精准营销"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="1300px"
        >
          <div class="text-center warning-tip">
            <span class="el-icon-warning"></span>
            初次开启建议根据您用户的情况设置，设置后不能自行修改了哦
          </div>
          <el-form
            label-width="0"
            :model="ruleFormShaft"
            :rules="rulesShaft"
            :inline="true"
            ref="ruleFormShaft"
          >
            <div class="flex physiological-set">
              <div class="flex-1" style="border-right: 1px solid #ddd">
                <div class="title">孕妇生理阶段划分</div>
                <div class="mt20 flex item-center">
                  <el-form-item prop="pregnantseparateValue">
                    按每
                    <el-input
                      clearable
                      size="small"
                      class="ml10 mr10"
                      v-model="ruleFormShaft.pregnantseparateValue"
                      @input="filterGt0OrFixed0('pregnantseparateValue')"
                      @mousewheel.prevent.native
                      style="width: 120px"
                      maxlength="50"
                      placeholder="请输入数字"
                    ></el-input>
                    周为一个阶段，最长
                  </el-form-item>
                  <el-form-item prop="pregnantendValue">
                    <el-input
                      clearable
                      size="small"
                      class="ml10 mr10"
                      v-model="ruleFormShaft.pregnantendValue"
                      @mousewheel.prevent.native
                      style="width: 120px"
                      maxlength="50"
                      placeholder="请输入数字"
                    ></el-input>
                    周
                  </el-form-item>
                </div>

                <div class="cycle p10">
                  <el-scrollbar
                    class="page-component__scroll"
                    style="height: 100%"
                  >
                    <div
                      class="cycle-box"
                      v-for="(v, i) in pregnantCycle"
                      :key="i"
                    >
                      {{ v }}
                    </div>
                  </el-scrollbar>
                </div>
              </div>

              <div class="flex-1 ml20">
                <div class="title">宝宝生理阶段划分</div>
                <div class="mt20">
                  <el-form-item prop="babyseparateValue">
                    按每
                    <el-input
                      clearable
                      size="small"
                      class="ml10 mr10"
                      v-model="ruleFormShaft.babyseparateValue"
                      @input="filterGt0OrFixed0('babyseparateValue')"
                      @mousewheel.prevent.native
                      style="width: 120px"
                      maxlength="50"
                      placeholder="请输入数字"
                    ></el-input>
                    个月为一个阶段，最长
                  </el-form-item>
                  <el-form-item prop="babyendValue">
                    <el-input
                      clearable
                      size="small"
                      class="ml10 mr10"
                      v-model="ruleFormShaft.babyendValue"
                      @mousewheel.prevent.native
                      style="width: 120px"
                      maxlength="50"
                      placeholder="请输入数字"
                    ></el-input>
                    个月
                  </el-form-item>
                </div>
                <div class="cycle p10">
                  <el-scrollbar
                    class="page-component__scroll"
                    style="height: 100%"
                  >
                    <div class="cycle-box" v-for="(v, i) in babyCycle" :key="i">
                      {{ v }}
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button
              size="small"
              type="primary"
              @click="submitReject('ruleFormShaft')"
              >立即开启精准营销</el-button
            >
            <el-button @click="dialogVisible = false" size="small"
              >取 消</el-button
            >
          </span>
        </el-dialog>
      </div>
      <hm-content title="">
        <div class="tip-title">开启母婴人群运营新时代</div>
        <div class="text-center tip-content">
          生理轴营销基于禾苗大数据的能力，集用户画像/精准推送/数据分析/孕妇生理轴/宝宝生理轴精准营销解决方案，并通过精细化的有效触达和营销服务，
        </div>
        <div class="text-center tip-content">
          实帮助商家精准触达消费者，最终实现商家转化率提升。
        </div>
        <div>
          <el-image
            style="width: 100%"
            src="https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
            fit="fill"
          ></el-image>
        </div>
      </hm-content>
    </div>
    <div v-show="!show">
      <div class="overview-box">
        <el-radio-group
          v-model="searchCondition.groupType"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="pregnant">孕妇生理轴</el-radio-button>
          <el-radio-button label="baby">宝宝生理轴</el-radio-button>
        </el-radio-group>
      </div>
      <div class="flex">
        <div class="select-cycle mr10">
          <el-scrollbar class="page-component__scroll" style="height: 100%">
            <div
              class="cycle-item pointer"
              :class="{ active: active === i }"
              v-for="(v, i) in selectCycleList"
              :key="i"
              @click="cycleDetail(i, v)"
            >
              {{ v.rangeName }}
            </div>
          </el-scrollbar>
        </div>
        <div class="flex-1 marketing-body">
          <el-scrollbar class="page-component__scroll" style="height: 100%">
            <div class="overview-box">
              <div class="title" v-if="searchCondition.tagId === ''">
                今日{{ title }}人群数据
              </div>
              <div class="title" v-else>
                今日{{ rangeName }}{{ title }}人群数据
              </div>
              <div
                class="flex flex-center mt20 mb10"
                v-if="searchCondition.tagId === ''"
              >
                <div
                  class="flex-1 flex purchase-data p10 pointer"
                  :class="{ mr20: i < list.length - 1 }"
                  @click="gogogo(v.pathName)"
                  v-for="(v, i) in list"
                  :key="i"
                >
                  <div class="hm-icon mr10">
                    <span class="hmicon" :class="v.icon"></span>
                  </div>
                  <div class="flex-1">
                    <div class="purchase-name mt10">
                      {{ v.name }}
                    </div>
                    <div class="mt10 flex flex-between item-center">
                      <div class="purchase-val">
                        {{ i !== 1 ? v.val : ToFixed(v.val, 2) + "%" }}
                      </div>
                      <div style="font-size: 14px">
                        <span class="mr10"
                          >昨日
                          {{
                            i !== 1
                              ? v.yesterdayTotal
                              : ToFixed(v.yesterdayTotal, 2) + "%"
                          }}
                        </span>
                        增减
                        <span class="success" v-if="v.subTotal >= 0"
                          >+{{
                            i !== 1 ? v.subTotal : ToFixed(v.subTotal, 2) + "%"
                          }}</span
                        >
                        <span
                          class="el-icon-top success"
                          v-if="v.subTotal >= 0"
                        ></span>
                        <span class="danger" v-if="v.subTotal < 0">
                          {{
                            i !== 1 ? v.subTotal : ToFixed(v.subTotal, 2) + "%"
                          }}</span
                        >
                        <span
                          class="el-icon-bottom danger"
                          v-if="v.subTotal < 0"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-center mt20 mb10" v-else>
                <div
                  class="flex-1 flex purchase-data p10 pointer"
                  :class="{ mr10: i < rangelist.length - 1 }"
                  @click="gogogo(v.pathName)"
                  v-for="(v, i) in rangelist"
                  :key="i"
                  v-if="i != 1"
                >
                  <div class="hm-icon mr10">
                    <span class="hmicon" :class="v.icon"></span>
                  </div>
                  <div class="flex-1">
                    <div class="purchase-name mt10">
                      {{ v.name }}
                    </div>
                    <div class="mt10 flex flex-between item-center">
                      <div class="purchase-val" style="font-size: 18px">
                        {{
                          i !== 1 && i !== 2 ? v.val : ToFixed(v.val, 2) + "%"
                        }}
                      </div>
                      <div style="font-size: 13px">
                        <span style="margin-right: 5px"
                          >昨日
                          {{
                            i !== 1 && i !== 2
                              ? v.yesterdayTotal
                              : ToFixed(v.yesterdayTotal, 2) + "%"
                          }}
                        </span>
                        增减
                        <span class="success" v-if="v.subTotal >= 0"
                          >+{{
                            i !== 1 && i !== 2
                              ? v.subTotal
                              : ToFixed(v.subTotal, 2) + "%"
                          }}</span
                        >
                        <span
                          class="el-icon-top success"
                          v-if="v.subTotal >= 0"
                        ></span>
                        <span class="danger" v-if="v.subTotal < 0">
                          {{
                            i !== 1 && i !== 2
                              ? v.subTotal
                              : ToFixed(v.subTotal, 2) + "%"
                          }}</span
                        >
                        <span
                          class="el-icon-bottom danger"
                          v-if="v.subTotal < 0"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="overview-box" v-if="searchCondition.tagId === ''">
              <div class="flex flex-between">
                <div class="title">{{ title }}生理轴概览</div>
                <div>
                  <el-radio-group
                    v-model="searchCondition.radioType"
                    @change="radioTypeChange"
                  >
                    <el-radio label="all">全部</el-radio>
                    <el-radio label="nolike"
                      >未设置猜你喜欢规则({{ notSetRecommendNumber }})</el-radio
                    >
                    <el-radio label="nomsg"
                      >未设置消息推送计划({{ notSetMsgSendNumber }})</el-radio
                    >
                  </el-radio-group>
                </div>
              </div>
              <div class="mt20 physiological-overview">
                <el-scrollbar
                  class="page-component__scroll"
                  style="height: 100%"
                >
                  <ul class="flex flex-wrap">
                    <li
                      class="overview-item pointer"
                      v-for="(v, i) in overviewList"
                      :key="i"
                      :class="{
                        warningcycle: v.warningcycle,
                        dangercycle: v.dangercycle
                      }"
                      @click="cycleDetail(i, v, 'cycle')"
                    >
                      <div class="time">
                        {{ v.rangeName }}
                      </div>
                      <div
                        class="tip pointer"
                        @click.stop="addRule(v)"
                        v-if="!v.recommendRuleId"
                      >
                        未设置猜你喜欢规则，
                        <el-button size="small" type="text" class="blue"
                          >立即设置
                        </el-button>
                      </div>
                      <div class="tip" v-else @click.stop="editHomeRule(v)">
                        已设置猜你喜欢推荐规则，<el-button
                          class="blue"
                          size="small"
                          type="text"
                          >修改
                        </el-button>
                      </div>
                      <div class="tip" v-if="v.msgSendNum">
                        已有{{ v.msgSendNum }}条消息推送
                      </div>
                      <div class="tip pointer" @click.stop="addPlan(v)" v-else>
                        未设置消息推送计划，
                        <el-button class="blue" size="small" type="text"
                          >添加计划
                        </el-button>
                      </div>
                    </li>
                  </ul>
                </el-scrollbar>
              </div>
            </div>
            <div class="overview-box" v-show="searchCondition.tagId === ''">
              <div class="flex flex-between">
                <div class="title">{{ title }}人群分布</div>
                <div style="color: #999; font-size: 14px">
                  计算于：{{ computationTime }}
                </div>
              </div>
              <!-- <div class="flex flex-end mt10">
                <el-select
                  size="small"
                  clearable
                  placeholder="请选择"
                  v-model="searchCondition.drawDate"
                  class="mr10"
                  filterable
                >
                  <el-option label="7" value="前七项"></el-option>
                </el-select>
              </div> -->
              <div>
                <div
                  v-show="option.xAxis.data.length"
                  id="main"
                  style="height: 400px"
                ></div>
                <div
                  class="flex flex-center item-center gray"
                  v-if="option.xAxis.data.length === 0"
                  style="height: 400px"
                >
                  暂无人群统计数据，初次设置明日查看
                </div>
              </div>
            </div>
            <div
              class="overview-box"
              v-if="searchCondition.tagId === ''"
              v-show="false"
              style="max-width: 100%; overflow-y: auto"
            >
              <div class="flex flex-between">
                <div class="title">消息推送计划效果</div>
                <div style="color: #999; font-size: 14px">
                  计算于：{{ computationTime }}
                </div>
              </div>
              <div class="flex flex-between mt10">
                <div class=" " style="width: 49%">
                  <div class="effect">
                    <span class="hmicon icon-paiming"></span> 推送计划效果TOP5
                  </div>
                  <el-table
                    stripe
                    ref="table"
                    :data="topList"
                    id="table"
                    style="width: 100%"
                    size="small"
                  >
                    <el-table-column
                      type="index"
                      label="排名"
                      header-align="center"
                      align="center"
                      column-key="index"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="planName"
                      label="计划名称"
                      width="150"
                      column-key="planName"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="planRangeName"
                      label="人群"
                      column-key="planRangeName"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="proportion"
                      label="转化率"
                      column-key="proportion"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="planStatus"
                      label="状态"
                      column-key="planStatus"
                    >
                      <template slot-scope="scope">
                        <div
                          v-if="scope.row.planStatus === 'notStart'"
                          class="gray"
                        >
                          未开始
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'running'"
                          class="success"
                        >
                          进行中
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'end'"
                          class="gray"
                        >
                          已结束
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'errorStop'"
                          class="danger"
                        >
                          异常暂停
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'stop'"
                          class="orange"
                        >
                          暂停
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      header-align="center"
                      align="center"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-button
                          @click="dataVivew(scope.row)"
                          size="small"
                          class="blue"
                          type="text"
                          >数据</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="edit(scope.row)"
                          size="small"
                          class="blue"
                          type="text"
                          >编辑</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="" style="width: 49%">
                  <div class="effect">
                    <span class="hmicon icon-paiming"></span>
                    推送计划效果最后5名
                  </div>
                  <el-table
                    stripe
                    ref="table"
                    :data="lastTopList"
                    id="table"
                    size="small"
                    style="width: 100%"
                  >
                    <el-table-column
                      type="index"
                      label="排名"
                      header-align="center"
                      align="center"
                      column-key="index"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="planName"
                      label="计划名称"
                      width="150"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="planRangeName"
                      label="人群"
                      column-key="planRangeName"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="proportion"
                      label="转化率"
                      column-key="proportion"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="planStatus"
                      label="状态"
                      column-key="planStatus"
                    >
                      <template slot-scope="scope">
                        <div
                          v-if="scope.row.planStatus === 'notStart'"
                          class="gray"
                        >
                          未开始
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'running'"
                          class="success"
                        >
                          进行中
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'end'"
                          class="gray"
                        >
                          已结束
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'errorStop'"
                          class="danger"
                        >
                          异常暂停
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'stop'"
                          class="orange"
                        >
                          暂停
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      header-align="center"
                      align="center"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-button
                          @click="dataVivew(scope.row)"
                          size="small"
                          class="blue"
                          type="text"
                          >数据</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="edit(scope.row)"
                          size="small"
                          class="blue"
                          type="text"
                          >编辑</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>

            <div v-else class="overview-box">
              <div class="flex mt10">
                <div class="flex-1 mr10" style="width: 40%">
                  <div class="title mb10">猜你喜欢商品</div>
                  <el-button size="small" type="primary" @click="editRule"
                    >{{ isSetRule ? "修改" : "设置" }}推荐规则</el-button
                  >
                  <el-table
                    v-if="isSetRule"
                    ref="btable"
                    :data="rulsList"
                    style="width: 100%; margin-top: 20px"
                    id="table"
                    :show-header="false"
                    size="small"
                    :row-style="showRow"
                  >
                    <el-table-column
                      header-align="right"
                      align="right"
                      prop="name"
                      width="100"
                      key="name"
                    >
                      <template slot-scope="scope">
                        <div class="guess-like">
                          {{ scope.row.name }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="left"
                      align="left"
                      prop="content"
                      key="content"
                    >
                      <template slot-scope="scope">
                        <div>
                          <div
                            @click="goodsDetails(scope.row)"
                            class="blue pointer"
                            v-if="scope.row.name === '商品数量'"
                          >
                            {{ scope.row.content }}
                          </div>
                          <div v-else>
                            {{ scope.row.content }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div
                    v-else
                    class="form-item-tip mt10"
                    style="font-size: 15px"
                  >
                    暂未配置推荐规则！
                  </div>
                  <!-- <div class="mt20">
                    <div class="flex">
                      <div class="text-right guess-like mr10">商品标签</div>
                      <div>包含测孕纸、牛奶、孕妇衣服等商品聚合</div>
                    </div>
                    <div class="flex mt10">
                      <div class="text-right guess-like mr10">商品数量</div>
                      <div>包含测孕纸、牛奶、孕妇衣服等商品聚合</div>
                    </div>
                    <div class="flex mt10">
                      <div class="text-right guess-like mr10">展示数量去重</div>
                      <div>同一物品推荐展示后1条内不</div>
                    </div>
                    <div class="flex mt10">
                      <div class="text-right guess-like mr10">展示时间去重</div>
                      <div>同一物品推荐展示后1条内不</div>
                    </div>
                    <div class="flex mt10">
                      <div class="text-right guess-like mr10">点击数量去重</div>
                      <div>同一物品推荐展示后1条内不</div>
                    </div>
                    <div class="flex mt10">
                      <div class="text-right guess-like mr10">点击时间去重</div>
                      <div>同一物品推荐展示后1条内不</div>
                    </div>
                  </div> -->
                </div>
                <div class="flex-1" style="width: 60%">
                  <div class="flex flex-between mb10">
                    <div class="title">
                      消息推送计划（{{ planList.length }}）
                    </div>
                    <div
                      class="gray pointer"
                      style="font-size: 14px"
                      @click="more"
                    >
                      更多 <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                  <el-button
                    size="small"
                    type="primary"
                    @click="addPlan(selectCycleList[active])"
                    >创建推送计划</el-button
                  >
                  <el-table
                    class="mt20"
                    stripe
                    ref="btable"
                    :data="planList"
                    style="width: 100%"
                    id="table"
                    size="small"
                    :header-row-style="showRow"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="planName"
                      label="计划名称"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="categoryName"
                      label="计划时间"
                      width="200"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.planStartDate }}至{{
                          scope.row.planEndDate
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="proportion"
                      label="转化率"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="状态"
                    >
                      <template slot-scope="scope">
                        <div
                          v-if="scope.row.planStatus === 'notStart'"
                          class="gray"
                        >
                          未开始
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'running'"
                          class="success"
                        >
                          进行中
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'end'"
                          class="gray"
                        >
                          已结束
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'errorStop'"
                          class="danger"
                        >
                          异常暂停
                        </div>
                        <div
                          v-else-if="scope.row.planStatus === 'stop'"
                          class="orange"
                        >
                          暂停
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          class="blue"
                          type="text"
                          @click="dataVivew(scope.row)"
                          >数据</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          size="small"
                          class="blue"
                          type="text"
                          @click="edit(scope.row)"
                          >编辑</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="operate(scope.row)"
                          v-if="
                            scope.row.planStatus === 'notStart' ||
                              scope.row.planStatus === 'end'
                          "
                          size="small"
                          type="text"
                          class="gray"
                          :disabled="
                            scope.row.planStatus === 'notStart' ||
                              scope.row.planStatus === 'end'
                          "
                          >{{
                            scope.row.planStatus === "errorStop" ||
                            scope.row.planStatus === "stop"
                              ? "开启"
                              : "暂停"
                          }}</el-button
                        >
                        <el-button
                          @click="operate(scope.row)"
                          v-else
                          size="small"
                          type="text"
                          :class="
                            scope.row.planStatus === 'errorStop' ||
                            scope.row.planStatus === 'stop'
                              ? 'success'
                              : 'orange'
                          "
                          >{{
                            scope.row.planStatus === "errorStop" ||
                            scope.row.planStatus === "stop"
                              ? "开启"
                              : "暂停"
                          }}</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          size="small"
                          class="danger"
                          type="text"
                          @click="del(scope.row)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="overview-box">
              <div class="flex flex-between">
                <div class="title">{{ rangeName }}{{ title }}人群行为统计</div>
                <div style="color: #999; font-size: 14px">
                  最近7天的统计数据（统计截止前一天）
                </div>
              </div>
              <div class="flex flex-end mt10">
                <el-select
                  size="small"
                  placeholder="请选择"
                  v-model="searchCondition.isPlus"
                  class="mr10"
                  filterable
                  @change="isPlusChange"
                >
                  <el-option
                    label="全部孕妇"
                    value=""
                    v-if="searchCondition.groupType === 'pregnant'"
                  ></el-option>
                  <el-option
                    label="全部宝宝"
                    value=""
                    v-if="searchCondition.groupType === 'baby'"
                  ></el-option>
                  <el-option label="PLUS会员" value="yes"></el-option>
                  <el-option label="非PLUS会员" value="no"></el-option>
                </el-select>
              </div>
              <div class="flex mt20">
                <div
                  v-for="(v, i) in h"
                  :key="i"
                  @click="detail(i, v)"
                  class="tab-btn text-center pointer"
                >
                  <div class="hh" :style="{ background: v.background }"></div>
                  <div
                    class="p10"
                    :style="{ background: activebtn === i ? v.rgba : '' }"
                  >
                    <div style="font-size: 14px">
                      {{ v.name }}
                    </div>
                    <div style="font-weight: bold; font-size: 20px">
                      {{ v.val }}
                    </div>
                  </div>
                </div>
              </div>
              <div style="height: 400px" v-show="optionLine.xAxis.data.length">
                <div
                  v-if="showCanvas"
                  id="mainline"
                  style="height: 400px"
                ></div>
              </div>
              <div
                class="flex flex-center item-center gray"
                v-if="optionLine.xAxis.data.length === 0"
                style="height: 400px"
              >
                暂无人群行为统计数据
              </div>
            </div>
            <div class="overview-box">
              <div class="flex flex-between">
                <div class="title">{{ rangeName }}{{ title }}人群商品兴趣</div>
                <div style="color: #999; font-size: 14px">
                  最近7天的统计数据（统计截止前一天）
                </div>
              </div>
              <div class="mt10">
                <el-radio-group
                  v-model="searchCondition.interestType"
                  @change="interestTypeChange"
                  size="small"
                >
                  <el-radio-button label="access">访问排行</el-radio-button>
                  <el-radio-button label="prepay">下单商品排行</el-radio-button>
                  <el-radio-button label="pay">成交商品排行</el-radio-button>
                </el-radio-group>
              </div>
              <div class="mt10">
                <el-table
                  stripe
                  ref="table"
                  :data="listRanking"
                  style="width: 100%"
                  id="table"
                  size="small"
                  max-height="300"
                >
                  <el-table-column
                    type="index"
                    label="排名"
                    header-align="center"
                    align="center"
                    column-key="index"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodName"
                    label="商品名称"
                    column-key="goodName"
                    width="600"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodPrice"
                    label="单价"
                    column-key="goodPrice"
                  >
                    <template slot-scope="scope">
                      ￥{{ scope.row.goodPrice || "0.00" }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="count"
                    label="人数"
                    column-key="count"
                    sortable
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        :title="dialogTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisibles"
        width="800px"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
        >
          <el-form-item label="指定人群">
            <div>{{ rangeName }}{{ title }}</div>
          </el-form-item>
          <el-form-item label="推荐方式">
            <div>个性化推荐</div>
          </el-form-item>
          <el-form-item label="指定商品" prop="goodsTagIdList">
            <el-button
              type="primary"
              size="small"
              @click="dialogVisiblelabel = true"
              >选择商品标签</el-button
            >
            <div class="from-item">
              已选标签({{ ruleForm.goodsTagIdList.length }})
            </div>
            <div>
              <el-tag
                v-for="(v, i) in ruleForm.goodsTagIdList"
                :key="i"
                closable
                @close="delTag(i)"
                :disable-transitions="false"
                type="info"
              >
                {{ v.tagName }}
              </el-tag>
            </div>
          </el-form-item>
          <!-- <el-form-item label="展示数量" prop="showNumDistinct">
            同一物品推荐展示后
            <el-input
              style="width: 100px"
              placeholder=""
              v-model="ruleForm.showNumDistinct"
              @input="filterGt0OrFixedform0('showNumDistinct')"
            >
            </el-input>
            条内不重复
          </el-form-item>
          <el-form-item label="展示时间" prop="showDayDistinct">
            同一物品推荐展示后
            <el-input
              style="width: 100px"
              placeholder=""
              v-model="ruleForm.showDayDistinct"
              @input="filterGt0OrFixedform0('showDayDistinct')"
            >
            </el-input>
            天内不重复
          </el-form-item>
          <el-form-item label="点击数量" prop="clickNumDistinct">
            同一物品推荐点击后
            <el-input
              style="width: 100px"
              placeholder=""
              v-model="ruleForm.clickNumDistinct"
              @input="filterGt0OrFixedform0('clickNumDistinct')"
            >
            </el-input>
            条内不重复
          </el-form-item>
          <el-form-item label="点击时间" prop="clickDayDistinct">
            同一物品推荐点击后
            <el-input
              style="width: 100px"
              placeholder=""
              v-model="ruleForm.clickDayDistinct"
              @input="filterGt0OrFixedform0('clickDayDistinct')"
            >
            </el-input>
            天内不重复
          </el-form-item> -->
        </el-form>

        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button size="small" type="primary" @click="submit('ruleForm')"
            >确 认</el-button
          >
          <el-button @click="dialogVisibles = false" size="small"
            >取 消</el-button
          >
        </span>
      </el-dialog>
      <hm-select-all-label
        ref="alllabel"
        :visible="dialogVisiblelabel"
        :enabelList="ruleForm.goodsTagIdList"
        @close="dialogVisiblelabel = false"
        @saveGoods="saveGoods"
      >
      </hm-select-all-label>
    </div>
  </div>
</template>

<script>
import { arrayUnique2, toPrice, ToFixed } from "@/utils/utils";
import HmSelectAllLabel from "@/components/HmSelectAllLabel";
import moment from "moment";
import echarts from "echarts";
// var echarts = require("echarts/lib/echarts");
// require("echarts/lib/chart/bar");
// // 引入提示框和图例组件
// require("echarts/lib/component/tooltip");
// require("echarts/lib/component/title");
// require("echarts/lib/component/legend");

export default {
  components: { HmSelectAllLabel },
  data() {
    const pregnantendValueFunc = (rule, val, callback) => {
      if (val > 40) {
        return callback(new Error("最大输入40"));
      } else {
        if (
          new Number(this.ruleFormShaft.pregnantseparateValue) >
          new Number(this.ruleFormShaft.pregnantendValue)
        ) {
          return callback(
            new Error(
              "该值应大于周期值（" +
                this.ruleFormShaft.pregnantseparateValue +
                ")"
            )
          );
        } else {
          callback();
        }
      }

      callback();
    };
    // const pregnantseparateValueFunc = (rule, val, callback) => {
    //   if (
    //     this.ruleFormShaft.pregnantseparateValue >
    //     this.ruleFormShaft.pregnantendValue
    //   ) {
    //     return callback(
    //       new Error(
    //         "应大于周期值（" + this.ruleFormShaft.pregnantseparateValue + ")"
    //       )
    //     );
    //   }
    //   callback();
    // };
    const babyseparateValueFunc = (rule, val, callback) => {
      if (val > 36) {
        return callback(new Error("最大输入36"));
      } else {
        if (
          new Number(this.ruleFormShaft.babyseparateValue) >
          new Number(this.ruleFormShaft.babyendValue)
        ) {
          return callback(
            new Error(
              "该值应大于周期值（" + this.ruleFormShaft.babyseparateValue + ")"
            )
          );
        } else {
          callback();
        }
      }

      callback();
    };
    return {
      ToFixed,
      isLoading: false,
      isSetRule: false,
      computationTime: "",
      row: {},
      dialogVisiblelabel: false,
      dialogVisibles: false,
      dialogTitle: "",
      rulsList: [
        {
          name: "商品标签",
          content: "包含测孕纸、牛奶、孕妇衣服等商品聚合"
        },
        {
          name: "商品数量",
          content: "约0条>"
        },
        {
          name: "展示数量",
          content: "同一物品推荐展示后1条内不重复"
        },
        {
          name: "展示时间",
          content: "同一物品推荐展示后1天内不重复"
        },
        {
          name: "点击数量",
          content: "同一物品推荐展示后1条内不重复"
        },
        {
          name: "点击时间",
          content: "同一物品推荐展示后1天内不重复"
        }
      ],
      planList: [],
      rangeName: "",
      activebtn: 0,
      h: [
        {
          name: "访问人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#B839F2",
          behaviorType: "visit",
          rgba:
            "linear-gradient(180deg, rgba(184, 57, 242, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "领券人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#F58D34",
          behaviorType: "getCoupon",

          rgba:
            "linear-gradient(180deg, rgba(245, 141, 52, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "加入购物车人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#16CEB9",
          behaviorType: "addCart",

          rgba:
            "linear-gradient(180deg, rgba(22, 206, 185, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "下单人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#0081E5",
          behaviorType: "prepay",
          rgba:
            "linear-gradient(180deg, rgba(0, 129, 229, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "成交人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#F53489",
          behaviorType: "pay",

          rgba:
            "linear-gradient(180deg, rgba(245, 52, 137, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        }
      ],
      topList: [],
      listRanking: [],
      lastTopList: [],
      optionLine: {
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" +
                params[i].marker +
                // params[i].seriesName +
                // " : " +
                params[i].value +
                "人";
            }
            return relVal;
          }
        },
        xAxis: {
          type: "category",
          data: [
            // "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"
          ]
        },
        yAxis: {
          type: "value",
          minInterval: 1
        },
        series: [
          {
            data: [
              // 820, 932, 901, 934, 1290, 1330, 1320
            ],
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#B839F2"
                }
              }
            },
            areaStyle: {
              color: "#B839F2"
            }
          }
        ]
      },
      option: {
        // ---  提示框 ----
        tooltip: {
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" +
                params[i].marker +
                // params[i].seriesName +
                // " : " +
                params[i].value +
                "人";
            }
            return relVal;
          },
          show: true, // 是否显示提示框，默认为true
          trigger: "axis", // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: "shadow",
            axis: "auto"
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: "#fff"
          }
        },
        xAxis: {
          axisTick: {
            // 坐标轴 刻度
            show: false, // 是否显示
            inside: true, // 是否朝内
            length: 3, // 长度
            lineStyle: {
              // 默认取轴线的样式
              color: "red",
              width: 1,
              type: "solid"
            }
          },
          type: "category",
          data: [
            // "1月",
            // "2月",
            // "3月",
            // "4月",
            // "5月",
            // "6月",
            // "7月",
            // "8月",
            // "9月",
            // "10月",
            // "11月",
            // "12月"
          ]
        },
        yAxis: {
          type: "value",
          minInterval: 1
        },
        dataZoom: [
          {
            start: 0,
            type: "inside"
          },
          {
            start: 9
          }
        ],
        series: [
          {
            barWidth: "70%", // 柱形的宽度
            barCategoryGap: "30%", // 柱形的间距
            data: [
              // 3000,
              // 4000,
              // 4200,
              // 4500,
              // 6000,
              // 5600,
              // 4500,
              // 5020,
              // 4500,
              // 5400,
              // 4300,
              // 1200
            ],
            type: "bar"
          }
        ]
      },
      copyOverviewList: [],
      overviewList: [],
      title: "孕妇",
      list: [
        {
          icon: "icon-zongrenshu",
          name: "总人数(人）",
          val: "0",
          pathName: "PhysiologicalPeople",
          yesterdayTotal: 0,
          subTotal: 0
        },
        {
          icon: "icon-zonghuiyuanzhongzhanbi",
          name: "总会员中占比(%）",
          val: "0",
          pathName: "PhysiologicalPeople",
          yesterdayTotal: 0,
          subTotal: 0
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "今日消息推送人数(人）",
          val: "0",
          pathName: "MessagesReachUsers",
          yesterdayTotal: 0,
          subTotal: 0
        }
      ],
      rangelist: [
        {
          icon: "icon-zongrenshu",
          name: "群体总人数(人）",
          val: "0",
          pathName: "PhysiologicalPeople",
          yesterdayTotal: 0,
          subTotal: 0
        },
        {
          icon: "icon-yunfuquntizhongzhanbi",
          name: "孕妇群体中占比(%）",
          val: "0",
          pathName: "PhysiologicalPeople",
          yesterdayTotal: 0,
          subTotal: 0
        },
        {
          icon: "icon-zonghuiyuanzhongzhanbi",
          name: "总会员中占比(%）",
          val: "0",
          pathName: "PhysiologicalPeople",
          yesterdayTotal: 0,
          subTotal: 0
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "今日消息通知人数(人）",
          val: "0",
          pathName: "MessagesReachUsers",
          yesterdayTotal: 0,
          subTotal: 0
        }
      ],
      active: 0,
      searchCondition: {
        groupType: "pregnant",
        searchTypes: "pregnant",
        radioType: "all",
        tagId: "",
        behaviorType: "visit",
        isPlus: "",
        interestType: "access"
      },
      selectCycleList: [
        { name: "概览", id: 100 },
        { name: "0-1周", id: 0 },
        { name: "1-2周", id: 1 },
        { name: "3-4周", id: 2 },
        { name: "5-6周", id: 3 },
        { name: "7-8周", id: 4 },
        { name: "9-10周", id: 5 }
      ],
      show: true,
      babyCycle: [],
      pregnantCycle: [],
      ruleForm: {
        showNumDistinct: "1",
        showDayDistinct: "1",
        clickNumDistinct: "1",
        clickDayDistinct: "1",
        goodsTagIdList: []
      },
      rules: {
        goodsTagIdList: {
          required: true,
          message: "请选择商品标签",
          trigger: "blur"
        },
        showNumDistinct: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        },
        showDayDistinct: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        },
        clickNumDistinct: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        },
        clickDayDistinct: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      },
      ruleFormShaft: {
        pregnantendValue: "",
        pregnantseparateValue: "",
        babyendValue: "",
        babyseparateValue: ""
      },
      rulesShaft: {
        pregnantendValue: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: pregnantendValueFunc,
            trigger: "blur"
          }
        ],
        pregnantseparateValue: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
          // {
          //   required: true,
          //   validator: pregnantseparateValueFunc,
          //   trigger: "blur"
          // }
        ],
        babyendValue: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: babyseparateValueFunc,
            trigger: "blur"
          }
        ],
        babyseparateValue: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ]
      },
      dialogVisible: false,
      notSetRecommendNumber: 0,
      notSetMsgSendNumber: 0,
      num: 0,
      addCart: [],
      payOrder: [],
      receiveCoupon: [],
      submitOrder: [],
      view: [],
      payOrderRank: [],
      submitOrderRank: [],
      viewRank: [],
      showCanvas: true
    };
  },
  computed: {},
  watch: {
    "ruleFormShaft.pregnantendValue": {
      handler() {
        if (
          this.ruleFormShaft.pregnantendValue &&
          this.ruleFormShaft.pregnantseparateValue
        ) {
          this.pregnantCycle = [];
          let num =
            this.ruleFormShaft.pregnantendValue /
            this.ruleFormShaft.pregnantseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.pregnantseparateValue *
                (i + 1)}`;
              this.pregnantCycle.push(item);
            } else {
              if (
                this.ruleFormShaft.pregnantseparateValue * (i + 1) >
                this.ruleFormShaft.pregnantendValue
              ) {
                let item = `${this.pregnantCycle[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.pregnantendValue
                }`;
                this.pregnantCycle.push(item);
              } else {
                let item = `${this.pregnantCycle[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.pregnantseparateValue *
                  (i + 1)}`;
                this.pregnantCycle.push(item);
              }
            }
          }
          this.pregnantCycle.forEach((v, i) => {
            this.pregnantCycle[i] = `${v}周`;
          });
          this.pregnantCycle.push(
            this.ruleFormShaft.pregnantendValue + "周以上"
          );
        } else {
          this.pregnantCycle = [];
        }
      },
      deep: true
    },
    "ruleFormShaft.pregnantseparateValue": {
      handler() {
        if (
          this.ruleFormShaft.pregnantendValue &&
          this.ruleFormShaft.pregnantseparateValue
        ) {
          this.pregnantCycle = [];
          let num =
            this.ruleFormShaft.pregnantendValue /
            this.ruleFormShaft.pregnantseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.pregnantseparateValue *
                (i + 1)}`;
              this.pregnantCycle.push(item);
            } else {
              if (
                this.ruleFormShaft.pregnantseparateValue * (i + 1) >
                this.ruleFormShaft.pregnantendValue
              ) {
                let item = `${this.pregnantCycle[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.pregnantendValue
                }`;
                this.pregnantCycle.push(item);
              } else {
                let item = `${this.pregnantCycle[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.pregnantseparateValue *
                  (i + 1)}`;
                this.pregnantCycle.push(item);
              }
            }
          }
          this.pregnantCycle.forEach((v, i) => {
            this.pregnantCycle[i] = `${v}周`;
          });
          this.pregnantCycle.push(
            this.ruleFormShaft.pregnantendValue + "周以上"
          );
        } else {
          this.pregnantCycle = [];
        }
      },
      deep: true
    },
    "ruleFormShaft.babyendValue": {
      handler() {
        if (
          this.ruleFormShaft.babyendValue &&
          this.ruleFormShaft.babyseparateValue
        ) {
          this.babyCycle = [];
          let num =
            this.ruleFormShaft.babyendValue /
            this.ruleFormShaft.babyseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.babyseparateValue * (i + 1)}`;
              this.babyCycle.push(item);
            } else {
              if (
                this.ruleFormShaft.babyseparateValue * (i + 1) >
                this.ruleFormShaft.babyendValue
              ) {
                let item = `${this.babyCycle[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.babyendValue
                }`;
                this.babyCycle.push(item);
              } else {
                let item = `${this.babyCycle[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.babyseparateValue *
                  (i + 1)}`;
                this.babyCycle.push(item);
              }
            }
          }
          this.babyCycle.forEach((v, i) => {
            this.babyCycle[i] = `${v}月`;
          });
          this.babyCycle.push(this.ruleFormShaft.babyendValue + "月以上");
        } else {
          this.babyCycle = [];
        }
      },
      deep: true
    },
    "ruleFormShaft.babyseparateValue": {
      handler() {
        if (
          this.ruleFormShaft.babyendValue &&
          this.ruleFormShaft.babyseparateValue
        ) {
          this.babyCycle = [];
          let num =
            this.ruleFormShaft.babyendValue /
            this.ruleFormShaft.babyseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.babyseparateValue * (i + 1)}`;
              this.babyCycle.push(item);
            } else {
              if (
                this.ruleFormShaft.babyseparateValue * (i + 1) >
                this.ruleFormShaft.babyendValue
              ) {
                let item = `${this.babyCycle[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.babyendValue
                }`;
                this.babyCycle.push(item);
              } else {
                let item = `${this.babyCycle[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.babyseparateValue *
                  (i + 1)}`;
                this.babyCycle.push(item);
              }
            }
          }
          this.babyCycle.forEach((v, i) => {
            this.babyCycle[i] = `${v}月`;
          });
          this.babyCycle.push(this.ruleFormShaft.babyendValue + "月以上");
        } else {
          this.babyCycle = [];
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.queryPhysiologicalList();
    this.computationTime = moment(new Date())
      .add(-1, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    this.num = 0;
    // if (!this.show) {
    //   this.categoryLine();
    //   this.category(this.optionLine);
    // }
  },

  activated() {
    if (!this.show) {
      if (this.num) {
        this.categoryLine();
        this.queryPhysiologicalOverviewList();
        if (this.rangeName !== "全部") {
          this.cycleDetail(this.active, this.selectCycleList[this.active]);
        }
      }
      this.num++;
    }

    // this.queryPhysiologicalList();
  },
  methods: {
    delTag(i) {
      this.ruleForm.goodsTagIdList.splice(i, 1);
    },
    async queryTop5List() {
      const params = {
        pageSize: 5,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryAgeGroupPlanInfoPageList",
        params
      );
      if (code === "0") {
        const { records } = result;
        records.forEach(v => {
          v.proportion = v.totalNoticeNum
            ? (v.totalPayNum / v.totalNoticeNum).toFixed(2) + "%"
            : "0%";
        });
        this.topList = records;
      }
    },
    async queryLast5List() {
      const params = {
        pageSize: 5,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryAgeGroupPlanInfoPageList",
        params
      );
      if (code === "0") {
        const { records } = result;
        records.forEach(v => {
          v.proportion = v.totalNoticeNum
            ? (v.totalPayNum / v.totalNoticeNum).toFixed(2) + "%"
            : "0%";
        });
        this.lastTopList = records;
      }
    },
    more() {
      this.$router.push({
        name: "MessagesPush"
        // query: {
        //   row: JSON.stringify(row)
        // }
      });
    },
    dataVivew(row) {
      this.$router.push({
        name: "PlanningData",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    del(row) {
      this.$confirm("是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        row.operateType = "del";
        this.$store.dispatch("operateStoreRepurchasePlan", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryPlanList();
          }
        });
      });
    },
    operate(row) {
      let params = {
        id: row.id,
        operateType: "enabledState",
        enabledState:
          row.planStatus === "errorStop" || row.planStatus === "stop"
            ? "yes"
            : "no"
      };

      this.$store.dispatch("operateStoreRepurchasePlan", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryPlanList();
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "SetMessagesPush",
        query: {
          type: "edit",
          row: JSON.stringify(row)
        }
      });
    },
    data(row) {
      this.$router.push({
        name: "PlanningData",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    async queryPlanList() {
      const params = {
        pageSize: 5,
        pageNo: 1,
        targetId: this.searchCondition.tagId
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryAgeGroupPlanInfoPageList",
        params
      );
      if (code === "0") {
        const { records } = result;
        records.forEach(v => {
          v.proportion = v.totalNoticeNum
            ? (v.totalPayNum / v.totalNoticeNum).toFixed(2) + "%"
            : "0%";
        });
        this.planList = records;
      }
    },
    interestTypeChange() {
      // this.queryPhysiologicalInterestList();
      this.tabRankList();
    },
    goodsDetails(row) {
      this.$router.push({
        name: "PhysiologicalGoodsDetails",
        query: {
          recommendId: row.recommendId
        }
      });
    },
    radioTypeChange(val) {
      if (val === "all") {
        this.overviewList = this.copyOverviewList;
      } else if (val === "nolike") {
        this.overviewList = this.copyOverviewList.filter(
          v => !v.recommendRuleId
        );
      } else if (val === "nomsg") {
        this.overviewList = this.copyOverviewList.filter(v => !v.msgSendNum);
      }
      // this.queryPhysiologicalOverviewList();
    },
    gogogo(pathName) {
      this.$router.push({
        name: pathName,
        query: {
          searchCondition: JSON.stringify(this.searchCondition),
          rangeName: this.rangeName
        }
      });
    },
    saveGoods(checkedRowList) {
      this.ruleForm.goodsTagIdList.push.apply(
        this.ruleForm.goodsTagIdList,
        checkedRowList
      );
      this.ruleForm.goodsTagIdList = arrayUnique2(
        this.ruleForm.goodsTagIdList,
        "id"
      );
      this.$forceUpdate();
      this.dialogVisiblelabel = false;
    },
    filterGt0OrFixedform0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    addPlan(v) {
      let row = Object.assign(v, this.searchCondition);
      this.$router.push({
        name: "SetMessagesPush",
        query: {
          row: JSON.stringify(row),
          type: "add"
        }
      });
    },
    addRule(v) {
      this.row = v;
      this.dialogTitle = "猜你喜欢规则";
      this.dialogVisibles = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
      });
    },
    async editHomeRule(v) {
      const { code, result } = await this.$store.dispatch(
        "queryRecommendRuleConfigInfo",
        {
          targetId: v.id
        }
      );
      if (code === "0") {
        this.row = v;
        this.dialogVisibles = true;
        this.dialogTitle = "修改猜你喜欢规则";
        this.rangeName = v.rangeName;
        this.ruleForm.goodsTagIdList = [];
        result.goodsTagIdList.forEach((v, i) => {
          this.ruleForm.goodsTagIdList.push({
            id: result.goodsTagIdList[i],
            tagKey: result.goodsTagKeyList[i],
            tagName: result.goodsTagNameList[i]
          });
        });
        // this.ruleForm.goodsTagIdList;
        this.ruleForm.showNumDistinct = result.showNumDistinct;
        this.ruleForm.showDayDistinct = result.showDayDistinct;
        this.ruleForm.clickNumDistinct = result.clickNumDistinct;
        this.ruleForm.clickDayDistinct = result.clickDayDistinct;
      }
    },
    editRule() {
      this.dialogTitle = "猜你喜欢规则";
      this.dialogVisibles = true;
      if (this.isSetRule) {
        this.queryRecommendRuleConfigInfo().then(res => {
          this.ruleForm.goodsTagIdList = [];
          res.goodsTagIdList.forEach((v, i) => {
            this.ruleForm.goodsTagIdList.push({
              id: res.goodsTagIdList[i],
              tagKey: res.goodsTagKeyList[i],
              tagName: res.goodsTagNameList[i]
            });
          });
          // this.ruleForm.goodsTagIdList;
          this.ruleForm.showNumDistinct = res.showNumDistinct;
          this.ruleForm.showDayDistinct = res.showDayDistinct;
          this.ruleForm.clickNumDistinct = res.clickNumDistinct;
          this.ruleForm.clickDayDistinct = res.clickDayDistinct;
        });
      } else {
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields();
        });
      }
    },
    //猜你喜欢规则详情
    async queryRecommendRuleConfigInfo() {
      if (this.searchCondition.tagId !== "") {
        let params = {
          targetId: this.searchCondition.tagId
        };
        const { code, result } = await this.$store.dispatch(
          "queryRecommendRuleConfigInfo",
          params
        );

        if (code === "0") {
          if (result) {
            this.isSetRule = true;
            this.rulsList[0].content = result.goodsTagNames;
            this.rulsList[1].content = result.predictGoodsNum
              ? "约" + result.predictGoodsNum + "条>"
              : "约0条>";
            this.rulsList[1].recommendId = result.id;
            this.rulsList[2].content =
              "同一物品推荐展示后" + result.showNumDistinct + "条内不重复";
            this.rulsList[3].content =
              "同一物品推荐展示后" + result.showDayDistinct + "天内不重复";
            this.rulsList[4].content =
              "同一物品推荐展示后" + result.clickNumDistinct + "条内不重复";
            this.rulsList[5].content =
              "同一物品推荐展示后" + result.clickDayDistinct + "天内不重复";
            return result;
          } else {
            this.isSetRule = false;
          }
        }
      }
    },
    showRow() {
      let styleJson = {
        height: "49px"
      };
      return styleJson;
    },
    isPlusChange() {
      this.queryPhysiologicalBehaviorList();
    },
    querySwitchTab() {
      this.queryRecommendRuleConfigInfo();
      this.queryPhysiologicalBehaviorList();
      this.queryPlanList();
      this.qyertPhysiologicalInfo();
      this.queryPhysiologicalInterestList();
    },
    detail(i, v) {
      this.showCanvas = false;
      setTimeout(() => {
        this.showCanvas = true;
      }, 0);

      this.activebtn = i;

      this.optionLine.series[0].itemStyle.normal.lineStyle.color = v.background;
      this.optionLine.series[0].areaStyle.color = v.background;
      this.searchCondition.behaviorType = v.behaviorType;
      this.optionLine.xAxis.data = v.dateList;
      this.optionLine.series[0].data = v.countList;
      if (v.dateList.length) {
        setTimeout(() => {
          let myChart = echarts.init(document.getElementById("mainline"));
          myChart.setOption(this.optionLine, true);
        }, 500);
      }

      // myChart.resize();

      // this.queryPhysiologicalBehaviorList();
    },

    async queryPhysiologicalInterestList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      const { code, result } = await this.$store.dispatch(
        "queryPhysiologicalInterestList",
        searchCondition
      );
      if (code === "0") {
        const { payOrderRank, submitOrderRank, viewRank } = result;
        this.payOrderRank = payOrderRank;
        this.submitOrderRank = submitOrderRank;
        this.viewRank = viewRank;
        this.tabRankList();
      }
    },
    tabRankList() {
      if (this.searchCondition.interestType === "access") {
        this.listRanking = this.viewRank;
      } else if (this.searchCondition.interestType === "prepay") {
        this.listRanking = this.submitOrderRank;
      } else if (this.searchCondition.interestType === "pay") {
        this.listRanking = this.payOrderRank;
      }
      this.listRanking.forEach(v => {
        this.$set(v, "goodPrice", toPrice(ToFixed(v.goodPrice, 2)));
      });
    },
    async queryPhysiologicalBehaviorList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      const { code, result } = await this.$store.dispatch(
        "physiologicalBehaviorList",
        searchCondition
      );
      if (code === "0") {
        if (result) {
          const { report } = result;
          // this.payOrderRank = payOrderRank;
          // this.submitOrderRank = submitOrderRank;
          // this.viewRank = viewRank;
          // this.tabRankList();

          const {
            addCart,
            payOrder,
            receiveCoupon,
            submitOrder,
            view
          } = report;
          this.addCart = addCart;
          this.payOrder = payOrder;
          this.receiveCoupon = receiveCoupon;
          this.submitOrder = submitOrder;
          this.view = view;
          this.h.forEach(v => {
            v.dateList = [];
            v.countList = [];
            v.val = 0;
          });
          view.forEach(v => {
            this.h[0].val += v.count;
            this.h[0].dateList.push(v.date);
            this.h[0].countList.push(v.count);
          });
          receiveCoupon.forEach(v => {
            this.h[1].val += v.count;
            this.h[1].dateList.push(v.date);
            this.h[1].countList.push(v.count);
          });
          addCart.forEach(v => {
            this.h[2].val += v.count;
            this.h[2].dateList.push(v.date);
            this.h[2].countList.push(v.count);
          });
          submitOrder.forEach(v => {
            this.h[3].val += v.count;
            this.h[3].dateList.push(v.date);
            this.h[3].countList.push(v.count);
          });
          payOrder.forEach(v => {
            this.h[4].val += v.count;
            this.h[4].dateList.push(v.date);
            this.h[4].countList.push(v.count);
          });
          this.optionLine.xAxis.data = this.h[this.activebtn].dateList;
          this.optionLine.series[0].data = this.h[this.activebtn].countList;
          // this.h.forEach(v => {
          //   v.val = result[v.behaviorType + "MemberNumber"] || 0;
          // });
          // setTimeout(() => {
          this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById("mainline"));
            myChart.setOption(this.optionLine);
          });
        }

        // }, 1000);
      }
    },
    async queryPhysiologicalOverviewList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      const { code, result } = await this.$store.dispatch(
        "physiologicalOverviewList",
        searchCondition
      );
      if (code === "0") {
        const {
          overviewList,
          notSetMsgSendNumber,
          notSetRecommendNumber
        } = result;
        overviewList.forEach(v => {
          if (!v.recommendRuleId && !v.msgSendNum) {
            v.dangercycle = true;
          } else {
            if (!v.recommendRuleId || !v.msgSendNum) {
              v.warningcycle = true;
            }
          }
        });
        this.copyOverviewList = JSON.parse(JSON.stringify(overviewList));
        this.overviewList = overviewList;
        this.notSetMsgSendNumber = notSetMsgSendNumber;
        this.notSetRecommendNumber = notSetRecommendNumber;
      }
    },
    async queryPhysiologicalList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      const { code, result } = await this.$store.dispatch(
        "queryPhysiologicalList",
        searchCondition
      );

      if (code === "0") {
        this.isLoading = false;
        if (result && result.length) {
          this.show = false;
          this.selectCycleList = result;
          this.selectCycleList.unshift({ rangeName: "全部", id: "" });
          this.searchCondition.axisId = this.selectCycleList[1].axisId;

          this.queryPhysiologicalOverviewList();

          this.categoryLine();
          this.queryTop5List();
          this.queryLast5List();
          this.querySwitchTab();

          // this.queryPlanList();
        } else {
          this.show = true;
        }
        return result;
      }
    },
    async qyertPhysiologicalInfo() {
      this.searchCondition.axisId = this.selectCycleList[1].axisId;
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      const { code, result } = await this.$store.dispatch(
        "physiologicalInfo",
        searchCondition
      );
      if (code === "0") {
        if (searchCondition.tagId === "") {
          this.list.forEach((v, i) => {
            if (i === 0) {
              v.val = result.todayTotalMemberNumber || 0;

              v.yesterdayTotal = result.yesterdayTotalMemberNumber || 0;
              v.subTotal = result.subTotalMemberNumber || 0;
            } else if (i === 1) {
              v.val = result.todayPercent * 100 || 0;
              v.yesterdayTotal = result.yesterdayPercent.toFixed(2) * 100 || 0;
              v.subTotal = result.subPercent.toFixed(2) * 100 || 0;
            } else if (i === 2) {
              v.val = result.todayMsgPushNumber || 0;
              v.yesterdayTotal = result.yesterdayMsgPushNumber || 0;
              v.subTotal = result.subMsgPushNumber || 0;
            }
          });
        } else {
          this.rangelist.forEach((v, i) => {
            if (i === 0) {
              v.val = result.todayTotalMemberNumber || 0;
              v.yesterdayTotal = result.yesterdayTotalMemberNumber || 0;
              v.subTotal = result.subTotalMemberNumber || 0;
            } else if (i === 1) {
              if (this.searchCondition.groupType === "pregnant") {
                v.name = "孕妇群体中占比(%）";
              } else {
                v.name = "宝宝群体中占比(%）";
              }
              v.val = result.todayAgeGroupPercent.toFixed(2) * 100 || 0;
              v.yesterdayTotal =
                result.yesterdayAgeGroupPercent.toFixed(2) * 100 || 0;
              v.subTotal = result.subAgeGroupPercent.toFixed(2) * 100 || 0;
            } else if (i === 2) {
              v.val = result.todayPercent.toFixed(2) * 100 || 0;
              v.yesterdayTotal = result.yesterdayPercent.toFixed(2) * 100 || 0;
              v.subTotal = result.subPercent.toFixed(2) * 100 || 0;
            } else if (i === 3) {
              v.val = result.todayMsgPushNumber || 0;
              v.yesterdayTotal = result.yesterdayMsgPushNumber || 0;
              v.subTotal = result.subMsgPushNumber || 0;
            }
          });
        }
      }
    },
    async categoryLine() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // setTimeout(() => {
      const { code, result } = await this.$store.dispatch(
        "queryAgeGroupDistribution",
        searchCondition
      );
      if (code === "0") {
        let time = [];
        let data = [];
        result.forEach(v => {
          time.push(v.axisName);
          data.push(v.number);
        });
        this.option.xAxis.data = time;
        this.option.series[0].data = data;
        this.$nextTick(() => {
          const myChart = echarts.init(document.getElementById("main"));
          myChart.setOption(this.option);
          myChart.getZr().on("click", params => {
            let pointInPixel = [params.offsetX, params.offsetY];
            if (myChart.containPixel("grid", pointInPixel)) {
              let xIndex = myChart.convertFromPixel({ seriesIndex: 0 }, [
                params.offsetX,
                params.offsetY
              ])[0];
              console.log(xIndex);
            }
          });
        });
      }

      // myChart.on("click", function(param) {
      //   console.log("param: ", param);
      //   // console.log(param.data.name);
      // });
      // }, 1000);
    },
    cycleDetail(i, v, cycle) {
      if (cycle === "cycle") {
        this.active = i + 1;
      } else {
        this.active = i;
      }
      this.row = {};
      this.searchCondition.tagId = v.id;
      this.searchCondition.recommendRuleId = v.recommendRuleId;

      this.rangeName = v.rangeName;
      this.querySwitchTab();
    },
    async queryList() {},
    switchTab(val) {
      this.active = 0;
      this.searchCondition.tagId = "";
      this.title = val === "pregnant" ? "孕妇" : "宝宝";
      this.queryPhysiologicalList();
    },
    async submitReject(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleFormShaft));
        let list = [];
        for (let key in params) {
          if (key === "pregnantendValue") {
            list.push({
              endValue: params.pregnantendValue,
              separateValue: params.pregnantseparateValue,
              groupType: "pregnant",
              groupName: "孕妇生理周期"
            });
          } else if (key === "babyendValue") {
            list.push({
              endValue: params.babyendValue,
              separateValue: params.babyseparateValue,
              groupType: "baby",
              groupName: "宝宝年龄"
            });
          }
          //  else if (key === "memberendValue") {
          //   list.push({
          //     endValue: params.memberendValue,
          //     separateValue: params.memberseparateValue,
          //     groupType: "member",
          //     groupName: "会员年龄"
          //   });
          // }
        }
        this.$store.dispatch("edityAgeGroupConfig", list).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });

            this.dialogVisible = false;
            this.queryPhysiologicalList();
          }
        });
      } else {
        return false;
      }
    },
    async submit(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        let goodsTagIdList = [];
        params.goodsTagKeyList = [];
        params.goodsTagNameList = [];
        params.goodsTagIdList.forEach(v => {
          goodsTagIdList.push(v.id);
          params.goodsTagKeyList.push(v.tagKey);
          params.goodsTagNameList.push(v.tagName);
        });
        params.goodsTagIdList = goodsTagIdList;
        // params.goodsTagIds = params.goodsTagIds.join(",");
        // params.goodsTagKeys = params.goodsTagKeys.join(",");
        // params.goodsTagNames = params.goodsTagNames.join(",");
        // console.log("params", params);

        params.targetId = this.row.id || this.searchCondition.tagId;
        const { code } = await this.$store.dispatch(
          "queryRecommendRuleConfig",
          params
        );
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryPhysiologicalOverviewList().then(() => {
            this.radioTypeChange(this.searchCondition.radioType);
          });
          this.queryRecommendRuleConfigInfo();
          this.dialogVisibles = false;
        }
      } else {
        return false;
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleFormShaft[prop] = this.ruleFormShaft[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormShaft[prop] = this.ruleFormShaft[prop].replace(
        /^(0+)|[^\d]+/g,
        ""
      );
      this.ruleFormShaft[prop] = this.ruleFormShaft[prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    }
  }
};
</script>

<style lang="scss" scoped>
.overview-box {
  background: #fff;
  margin-bottom: 10px;
  padding: 20px;
  .title {
    color: #222222;
    font-weight: bold;
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
  .tit {
    // margin-top: 20px;
    color: #222;
    line-height: 40px;
    font-weight: bold;
    font-size: 20px;
  }
  .item-tip {
    color: #222;
    line-height: 24px;
    font-size: 14px;
  }
}
.tip-title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  line-height: 48px;
}
.tip-content {
  font-size: 14px;
  color: #999999;
  line-height: 22px;
}
.warning-tip {
  background: #fff1f1;
  color: red;
  font-size: 15px;
  padding: 10px;
  margin: -20px;
  .el-icon-warning {
    font-size: 17px;
  }
}
.physiological-set {
  margin-top: 50px;
  .cycle {
    background: #f9e8d9;
    border-radius: 4px;
    height: 355px;
    margin-right: 20px;
    .cycle-box {
      width: 129px;
      display: inline-block;
      margin-right: 12px;
      margin-bottom: 10px;
      border-left: 3px solid #ff7f10;
      height: 44px;
      line-height: 44px;
      text-align: center;
      color: #000;

      background: #fff8f1;
    }
  }
}
.select-cycle {
  background: #fff;
  // width: 140px;
  height: calc(100vh - 230px);
  .cycle-item {
    margin-left: 50px;
    font-size: 14px;
    line-height: 40px;
    width: 140px;
    &.active {
      color: #e50065;
    }
  }
}
.purchase-data {
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 24px;
    font-weight: bold;
  }
}
.physiological-overview {
  height: 400px;
  max-height: 400px;
  border: 1px solid #eee;
  .overview-item {
    width: 25%;
    box-sizing: border-box;
    // height: 106px;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    border-left: 4px solid #fff;
    padding: 20px 20px 10px 20px;
    .time {
      font-size: 18px;
      font-weight: bold;
      line-height: 25px;
    }
    .tip {
      font-size: 14px;
      color: #666666;
      line-height: 22px;
    }
    &.warningcycle {
      border-left: 4px solid #ff7f10;
      background: #fff8f1;
    }
    &.dangercycle {
      border-left: 4px solid #ff0000;
      background: #fff4f4;
    }
  }
}
.marketing-body {
  height: calc(100vh - 200px);
  min-width: 1000px;
  // width: calc(100% - 200px);
}
.effect {
  color: #666;
  line-height: 20px;
  font-size: 14px;
}
.tab-btn {
  width: 180px;
  margin-right: 33px;
  .hh {
    height: 4px;
    border-radius: 6px 6px 0px 0px;
  }
}
.guess-like {
  // width: 100px;
  color: #222;
  font-weight: bold;
}
</style>
